import axios from 'axios';
import { AdresseIP } from './AdresseIp';

/*
 * Échéancier de loyer d'un étudiant pour une cité.
 * Base : /campus-faso/echeancier-loyer
 *
 * Réponse :
 * {
 *   idEcheancierLoyer : number,
 *   idEtudiant : number, ine : string, nomEtudiant : string, prenomEtudiant : string,
 *   idCite : number, nomCite : string,
 *   idAnnee : number,
 *   montantMensuel : number, montantTotal : number,
 *   montantPaye : number, resteAPayer : number,
 *   dateDebutOccupation : string,
 *   echeances : [{
 *      idEcheanceLoyer : number,
 *      ordre : number,
 *      typeEcheance : "CAUTION" | "PREMIER_VERSEMENT" | "RESTE",
 *      nombreMois : number,
 *      montant : number,
 *      dateLimite : string,        // "dd-MM-yyyy" ou null
 *      statutPaiement : "PAYE" | "EN_COURS" | "IMPAYE",   // pilote l'UI
 *      payable : boolean,          // false tant que la caution n'est pas payée
 *      quittanceDisponible : boolean,
 *      paymentStatus : null | "INIT" | "PENDING" | "COMPLETED" | "EXPIRED" | "INCOMPLETE",
 *      paymentUrl : string, mappedOrderId : string
 *   }]
 * }
 */
export class EcheancierLoyerService {

    constructor(){
        this.adresse = new AdresseIP()
        this.url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/echeancier-loyer'
    }

    /* 409 si un échéancier ACTIF existe déjà pour cet étudiant + cette cité. */
    create(newEcheancier) {
        return axios.post(this.url, newEcheancier)
                    .then(res => res.data);
    }

    /*
     * Échéancier de l'étudiant pour une année académique : c'est l'appel de
     * l'écran étudiant. 404 si rien n'a encore été généré (lit non affecté ou
     * cité non paramétrée) : c'est une attente, pas une panne.
     *
     * idEtudiant vient du profil étudiant (EtudiantService.getByIne), surtout
     * pas du champ "id" du login qui est l'id du compte utilisateur.
     */
    getEcheancierAnnee(idEtudiant, idAnnee) {
        return axios.get(this.url+'/etudiant/'+idEtudiant+'/annee/'+idAnnee)
                    .then(res => res.data)
    }

    /* Historique : tous les échéanciers actifs de l'étudiant, le plus récent d'abord. */
    getEcheanciersEtudiant(ine) {
        return axios.get(this.url+'/etudiant/'+ine)
                    .then(res => res.data)
    }

}
